<script>
	import Footer from "../../components/Footer.svelte";
	import Cover from "./Cover.svelte";
	import Advantages from "./Advantages.svelte";
	import AdvantagesTwo from "./Advantages-two.svelte";
	import Dispatcher from "./Dispatcher.svelte";
	import ForDispatcher from "./ForDispatcher.svelte";
	import ForDriver from "./ForDriver.svelte";
	import ForAccountant from "./ForAccountant.svelte";
	import Pricing from "../../components/Pricing.svelte";
	import {getCurrentUser, onLogin} from "../../api/user";
	import {onMount} from "svelte";

	onMount(() => {
		onLogin(() => {
			if (getCurrentUser()) {
				let url = window.location.href;
				let params = new URLSearchParams(url.split('?')[1]);
				let code = params.get('code');
				if (code) {
					window.location = `/#/board?code=${code}`;
				} else {
					window.location = '/#/board';
				}
			}
		})
	})
</script>

<div class="landing">
	<!-- <Header/> -->
	<main>
		<Cover/>
		<Advantages/>
		<AdvantagesTwo/>
		<Dispatcher/>
		<ForDispatcher/>
		<ForDriver/>
		<ForAccountant/>
		<Pricing/>
	</main>
	<Footer/>
</div>

<style>
	:global(body) {
		padding: 0;
	}
	.landing {
		overflow-x: hidden;
		overflow-y: visible;
	}
</style>